import { get } from 'lodash';
import { useState, useEffect } from 'react';
import ajax from '../ajax';

async function fetchTranslations(key) {
    const response = await ajax.get(`i18n/${key}`);
    return response.data;
}

function useTranslations(namespace) {
    const [dictionary, setDictionary] = useState(null);
    const t = (key) => get(dictionary, key) || key;

    useEffect(() => {
        fetchTranslations(namespace).then(setDictionary);
    }, []);

    return [t, !!dictionary];
}

export { useTranslations };
